import React, { useState } from 'react';
import {faceAttributeValue } from '@nuralogix.ai/web-measurement-embedded-app';
import { Footer } from '@/shared/components/layout/Footer';

const Step2 = ({ data, onNext, onBack }) => {
const [history, setHistory] = useState({
        smoking: data.smoking,
        bloodPressureMedication: data.bloodPressureMedication,
        diabetes: data.diabetes,
    });

    const [errors, setErrors] = useState({
        smoking: false,
        bloodPressureMedication: false,
        diabetes: false
    });

    const handleContinue = () => {
        // Creamos un objeto de errores basado en si el valor está vacío o es null
        const newErrors = {
            smoking: !history.smoking && history.smoking !== 0,
            bloodPressureMedication: !history.bloodPressureMedication && history.bloodPressureMedication !== 0,
            diabetes: !history.diabetes && history.diabetes !== 0,
        };
        setErrors(newErrors);

        // Si alguno es true, hay un error y detenemos el flujo
        const hasAnyError = Object.values(newErrors).some(error => error === true);
        
        if (hasAnyError) return; // No permitimos avanzar

        // Si todo está bien, avanzamos
        onNext(history); // Envía los datos actualizados al padre
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        //Intentamos la conversión a número
        const numericValue = Number(value);

        // Verificamos si la conversión fue exitosa:
        // - !isNaN(numericValue): Comprueba que no sea NaN
        // - value.trim() !== "": Evita que un string vacío se convierta en 0
        const finalValue = (!isNaN(numericValue) && value.toString().trim() !== "") 
            ? numericValue 
            : value;

        setHistory(prev => ({
            ...prev,
            [name]: finalValue
        }));

        //Limpiar el error de este campo específico
        setErrors(prev => ({ ...prev, [name]: false }));
    };

    return (
        <div className="vitals-wrapper">
            <div className="container-vitals-top">
                <section className="section-vitals-top form-steps">
                    {/* Barra de Progreso - Clase step-2 activa */}
                    <div className="steps-wrapper step-2">
                        <div className="steps-bar">
                            <div className="steps-progress"></div>
                        </div>
                        <div className="steps-labels">
                            <span>Paso 1</span>
                            <span>Paso 2</span>
                            <span>Paso 3</span>
                        </div>
                    </div>

                    <div className="form-vitals">
                        <div className="arrow-back" onClick={onBack}>
                            <i className="icon icon_enlinea_flechita-izq back-card"></i>
                        </div>

                        <div className="title-form-vitals">
                            <i className="icon icon_enlinea_terminos_condiciones"></i>
                            Cuestionario de historial médico
                        </div>

                        <form>
                            {/* Fumas */}
                            <div className="mb-3">
                                <label className="form-label">¿Fumas?</label>
                                <select
                                    name="smoking"
                                    className={`form-control`}
                                    value={history.smoking}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled hidden>Selecciona</option>
                                    <option value={faceAttributeValue.SMOKER_FALSE}>No</option>
                                    <option value={faceAttributeValue.SMOKER_TRUE}>Si</option>
                                </select>
                                {errors.smoking && <p className="msj-error mt-2">Por favor selecciona una opción</p>}
                            </div>

                            {/* Medicina Presión */}
                            <div className="mb-3">
                                <label className="form-label">¿Usas medicina para la presión arterial?</label>
                                <select
                                    name="bloodPressureMedication"
                                    className="form-control"
                                    value={history.bloodPressureMedication}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled hidden>Selecciona</option>
                                    <option value={faceAttributeValue.BLOOD_PRESSURE_MEDICATION_FALSE}>No</option>
                                    <option value={faceAttributeValue.BLOOD_PRESSURE_MEDICATION_TRUE}>Si</option>
                                </select>
                                {errors.bloodPressureMedication && <p className="msj-error mt-2">Por favor selecciona una opción</p>}
                            </div>

                            {/* Diabético */}
                            <div className="mb-3">
                                <label className="form-label">¿Eres diabético?</label>
                                <select
                                    name="diabetes"
                                    className="form-control"
                                    value={history.diabetes}
                                    onChange={handleChange}
                                >
                                    <option value="" disabled hidden>Selecciona</option>
                                    <option value={faceAttributeValue.DIABETES_NONE}>No</option>
                                    <option value={faceAttributeValue.DIABETES_TYPE1}>Diabetes tipo 1</option>
                                    <option value={faceAttributeValue.DIABETES_TYPE2}>Diabetes tipo 2</option>
                                </select>
                                {errors.diabetes && <p className="msj-error mt-2">Por favor selecciona una opción</p>}
                            </div>

                            <div className="btn-form-vitals mt-8">
                                <button
                                    type="button"
                                    className="btn vitals-primary"
                                    onClick={() => handleContinue()}
                                >
                                    Continuar
                                </button>
                            </div>
                        </form>
                    </div>
                </section>
            </div>

            <Footer/>
        </div>
    );
};

export {Step2};